import React, { useEffect, useState } from 'react';
import { Input, Row, Col, Form } from 'antd';
import '../../styles/pages/_userProfileForm.scss';
import AvatarUpload from '../../components/avatarUpload';
import ChevronDown from '../../assets/icons/chevron-down.svg';
import { ReactComponent as CrosshairLightPurple } from '../../assets/icons/crosshair_lightpurple.svg';
import BusinessSizeCalculator from '../../components/businessSizeCalculator';
import { getDisplayCompanySizeLabel } from 'utils/helpers';
import { Select, Button, DatePicker } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import Calendar from '../../assets/icons/calendar_grey.svg';
import { getFundingAccount, updateFundingAccount } from 'store/user/actions';
import { getCompanyLogo, uploadCompanyLogo } from 'store/user/actions';
import { LegalFormOptions } from '../../utils/enums';
import {
  mapApiDataToForm,
  mapFormDataToApi,
} from './utils/userProfileForm.mapper';
import styles from '../login/confirmRegistration/ConfirmRegistration.module.scss';
import { companyFields, formItems } from './formfield';
import { omit } from 'lodash';
import { FormField } from 'components';
// import SubscriptionCardColumn from './subscriptionCardColumn';
// import { deleteCompanyLogo } from 'store/user/actions';

export const UserProfileForm = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const fundingAccount = useSelector(state => state.user?.fundingAccount);
  const data = fundingAccount?.data;
  const companyLogoInfo = useSelector(state => state.user?.companyLogo);
  const companyLogo = companyLogoInfo?.data;

  useEffect(() => {
    if (data) {
      form.setFieldsValue(mapApiDataToForm(data));
    }
  }, [data, form]);

  useEffect(() => {
    dispatch(getFundingAccount());
    dispatch(getCompanyLogo());
  }, [dispatch]);

  useEffect(() => {
    const savedRegion = localStorage.getItem('region');
    if (savedRegion) {
      form.setFieldsValue({ region: savedRegion });
    }
  }, [form]);

  const showModal = () => setIsModalVisible(true);

  const handleSaveCompanySize = businessSize => {
    form.setFieldsValue({
      displayValue: getDisplayCompanySizeLabel(businessSize),
    });
    setIsModalVisible(false);
  };

  const handleSaveChange = () => {
    const formValues = form.getFieldsValue();
    const payload = mapFormDataToApi(formValues);
    dispatch(updateFundingAccount(payload));
  };

  return (
    <div className="user-page">
      <div className="user-profile-form-container">
        <div className="user-profile-form-body">
          <Form
            form={form}
            layout="vertical"
            initialValues={mapApiDataToForm(data)}
            onFinish={handleSaveChange}
          >
            <div className="profile-container">
              <div className="profile-info-body">
                <AvatarUpload
                  id="avatar-upload"
                  className="profile-image"
                  image={companyLogo}
                  onUpload={file => {
                    const formData = new FormData();
                    formData.append('file', file);
                    dispatch(uploadCompanyLogo(formData));
                  }}
                  // onDelete={() => dispatch(deleteCompanyLogo())}
                />

                <div className="profile-text">
                  <span className="profile-title">
                    {mapApiDataToForm(data)?.companyName}
                  </span>
                  <div className="profile-afm">
                    <span className="afm-label">ΑΦΜ</span>
                    <span className="afm-number">
                      {mapApiDataToForm(data)?.afm}
                    </span>
                  </div>
                </div>
              </div>
              <div className="save-button-container">
                <Button
                  id="btn-save-profile"
                  className="save-button"
                  onClick={handleSaveChange}
                >
                  Αποθήκευση Αλλαγών
                </Button>
              </div>
            </div>
            <div className="info-body">
              <span className="info-title">Στοιχεία Επικοινωνίας</span>
              <Row className="row-wrapper" gutter={[24, 24]}>
                {formItems.map((field, index) => (
                  <Col
                    className="column-wrapper"
                    key={index}
                    span={field.span ?? 12}
                  >
                    <Form.Item
                      className="form-item-wrapper"
                      name={field.name}
                      rules={field.rules}
                      validateFirst
                    >
                      <FormField
                        disabled={field.disabled}
                        containerClassName={field.className}
                        label={
                          <span>
                            {field.label}
                            {field.asterisk && (
                              <span className="color-asterisk">*</span>
                            )}
                          </span>
                        }
                        {...omit(field, [
                          'span',
                          'rules',
                          'offset',
                          'disabled',
                          'label',
                          'asterisk',
                        ])}
                      />
                    </Form.Item>
                  </Col>
                ))}
              </Row>

              <div className="info-business-body">
                <span className="info-title">Στοιχεία Επιχείρησης</span>
                <Row className="row-wrapper" gutter={[24, 24]}>
                  {companyFields.map((field, index) => (
                    <Col
                      className="column-wrapper"
                      key={index}
                      span={field.span ?? 12}
                    >
                      <Form.Item
                        className="form-item-wrapper"
                        name={field.name}
                        rules={field.rules}
                        validateFirst
                      >
                        <FormField
                          disabled={field.disabled}
                          containerClassName={field.className}
                          label={
                            <span>
                              {field.label}
                              {field.asterisk && (
                                <span className="color-asterisk">*</span>
                              )}
                            </span>
                          }
                          {...omit(field, [
                            'span',
                            'rules',
                            'offset',
                            'disabled',
                            'label',
                            'asterisk',
                          ])}
                        />
                      </Form.Item>
                    </Col>
                  ))}
                </Row>

                <BusinessSizeCalculator
                  visible={isModalVisible}
                  onClose={() => setIsModalVisible(false)}
                  onSave={handleSaveCompanySize}
                />
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginTop: '8px',
                  }}
                >
                  <CrosshairLightPurple className="business-size-icon" />
                  <span className="businessSizeCalc" onClick={showModal}>
                    Βρες το μέγεθος της επιχείρησης
                  </span>
                </div>
              </div>

              {/* <div className="subscriptions-body">
              <div className="section-divider"> </div>
              <span className="subscriptions-title">My Subscriptions</span>
              <Row className="subscriptions-cards-wrapper">
                <SubscriptionCardColumn
                  title="Funding Advisor"
                  subtitle="Licence Details"
                  isActive={true}
                  expiryDate="21/10/26"
                />
                <SubscriptionCardColumn
                  title="Tax Advisor"
                  subtitle="Licence Details"
                  isActive={false}
                  expiryDate="21/10/26"
                />
                <SubscriptionCardColumn
                  title="Price Strategy & Elasticity"
                  subtitle="Licence Details"
                  isActive={false}
                  expiryDate="21/10/26"
                />
              </Row>
            </div> */}

              <div className="account-management-body">
                <div className="section-divider"> </div>
                <span className="account-title">Διαχείριση Λογαριασμού</span>
                {/* <div className="password-section">
                <span className="password">Κωδικός Πρόσβασης</span>
                <Button
                  className="password-button"
                  onClick={handlePasswordChange}
                >
                  Αλλαγή κωδικού πρόσβασης
                </Button>
              </div> */}
                <div className="account-info-section">
                  <span className="profile">Λογαριασμός</span>
                  <div className="section-divider-info"></div>
                  <span className="delete-info">
                    Για τη διαγραφή του λογαριασμού σου,
                    <span className="delete-info-light">
                      {' '}
                      παρακαλούμε επικοινώνησε με εκπρόσωπο Grant Thornton στο
                      210ΧΧΧΧΧΧΧ ή στο ΧΧΧΧΧΧ@gr.gt.com
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default UserProfileForm;
